import { Dialog } from "@mui/material";
import { BrandPanel } from "./Brand";
import { useEffect } from "react";

export function BrandDialog({
    showBrandDialog,
    setShowBrandDialog,
}) {
    return (
        <Dialog open={Boolean(showBrandDialog)} onClose={() => {
            setShowBrandDialog(false)
            
          }} >
            <BrandPanel noSetup={true} closeDialog={() => setShowBrandDialog(false)} />

        </Dialog>
    )
    
}